import React from 'react';
import Layout from '../components/layout';
import '../styles/order.scss';
import Order from '../components/order/order';

export default () => (
  <>
    <Layout>
      <Order />
    </Layout>
  </>
);
